import React from 'react';

import { DropDownList } from '@ast/magma/components/dropdownlist';

import { makeVar, useReactiveVar } from '@apollo/client';

import { useUserSettingsTranslation } from '@app/widgets/contacts-and-settings/hooks/useUserSettingsTranslation';

import {
  FieldComponent,
  FieldLocator,
  Field,
} from '../types';
import {
  combineNames,
  isSelectableGroupFiledInfo,
} from '../utils';

import { SelectableGroupFieldFragment as SelectableGroupField } from '../queries/queryTyping/all-fields';

import styles from './SelectableGroupFieldInfo.pcss';

// preserve select's state between page transitions
const currentId = makeVar<string | undefined>(undefined);
const setCurrentId = (id: string) => currentId(id);

export const SelectableGroupFieldComponent: FieldComponent<SelectableGroupField> = ({
  parent,
  field,
  locator,
}) => {
  const { t } = useUserSettingsTranslation();
  const subFields = field.fieldGroups;
  const currentFieldId = useReactiveVar(currentId) || subFields[0]?.id;
  const subField = subFields.find((item) => item?.id === currentFieldId) as Field;
  const Component = locator(subField);

  return (
    <div>
      {subFields.length > 1 ? (
        <DropDownList
          data={subFields}
          value={subField}
          getItemLabel={(item) => item?.label}
          className={styles.dropdown}
          label={t(
            'selectable-group-field-info.drop-down.label|Label for account selector',
            'Select account',
          )}
          data-stable-name="AccountSelector"
          onChange={(item) => setCurrentId(item.id)}
        />
      ) : null}
      <Component
        parent={combineNames(parent, field.id)}
        field={subField}
        locator={locator}
        key={subField.id}
      />
    </div>
  );
};

export const SelectableGroupFieldLocator: FieldLocator = (context) => (
  isSelectableGroupFiledInfo(context.field)
    ? SelectableGroupFieldComponent
    : undefined
);
